module.exports = __webpack_public_path__ + "1453937159b65471f67c44dcbded4313.svg";